import {
  ISoccerMatchCardEvent,
  ISoccerMatchEvent,
  ISoccerMatchGoalEvent,
  ISoccerMatchMissedPenaltyEvent,
  ISoccerMatchPenaltyShotEvent,
  ISoccerMatchSubstituteEvent,
  SoccerMatchEventType,
} from "../../../../../../types";
import {
  CardEvent,
  GoalEvent,
  MissedPenaltyEvent,
  PenaltyShotEvent,
  SubtituteEvent,
} from "./MatchKeyEventComponents";

export const MatchKeyEvent = ({
  teamId,
  event,
}: {
  teamId: { home: string; away: string };
  event: ISoccerMatchEvent;
}) => {
  const homeTeamEvent = teamId.home === event.contestantId ? event : null;
  const awayTeamEvent = teamId.away === event.contestantId ? event : null;

  switch (event.eventType) {
    case SoccerMatchEventType.CARD: {
      return (
        <CardEvent
          event={event as ISoccerMatchCardEvent}
          isHomeTeamEvent={!!homeTeamEvent}
          isAwayTeamEvent={!!awayTeamEvent}
        />
      );
    }
    case SoccerMatchEventType.MISSED_PENALTY: {
      return (
        <MissedPenaltyEvent
          event={event as ISoccerMatchMissedPenaltyEvent}
          isHomeTeamEvent={!!homeTeamEvent}
          isAwayTeamEvent={!!awayTeamEvent}
        />
      );
    }
    case SoccerMatchEventType.PENALTY_SHOT: {
      return (
        <PenaltyShotEvent
          event={event as ISoccerMatchPenaltyShotEvent}
          isHomeTeamEvent={!!homeTeamEvent}
          isAwayTeamEvent={!!awayTeamEvent}
        />
      );
    }
    case SoccerMatchEventType.GOAL: {
      return (
        <GoalEvent
          event={event as ISoccerMatchGoalEvent}
          isHomeTeamEvent={!!homeTeamEvent}
          isAwayTeamEvent={!!awayTeamEvent}
        />
      );
    }
    case SoccerMatchEventType.SUSTITUTE: {
      return (
        <SubtituteEvent
          event={event as ISoccerMatchSubstituteEvent}
          isHomeTeamEvent={!!homeTeamEvent}
          isAwayTeamEvent={!!awayTeamEvent}
        />
      );
    }
  }
};
